export default "__VITE_ASSET__DgQZLGyt__"